import './css/bottom-menu.css';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { useState } from 'react';
import {ArrowDropDown, PhoneInTalk, WhatsApp, Email, Twitter, Facebook} from '@material-ui/icons';

export default function BottomMenu() {
  const hoverEffect = {
    whileHover: { scale: 1.05, color: 'rgb(59, 194, 149)' },
    whileTap: { scale: 0.9 }
  }
  // const control = useAnimation();
  // const { ref, inView } = useInView({ threshold: 0.3 });
  return (
    <section id="preFooter" className="bottom-container">
      <div className="preFooterWrapper">
        <div className="bottom-container-first">
          <h2>Help links</h2>
          <div className="linkWrapper">
              <div className="preFooter-item">
                <h4 className="preFooter-btn">Products</h4>
                <a href="https://ideypay.com/sell-bitcoin">Marketplace (Peer-to-Peer)</a>
                <a href="https://ideypay.com/bitcoin">Bitcoin Wallet</a>
                <a href="https://ideypay.com/naira">Naira Wallet</a>
                <a href="https://ideypay.com/whyideypay.html">Buy/Sell E-Currencies</a>
              </div>
              <div className="preFooter-item">
                <h4 className="preFooter-btn">Company </h4>
                <a href="https://ideypay.com/affiliates">Affiliates</a>
                <a href="https://ideypay.com/partners">Partners</a>
                <a href="https://ideypay.com/terms.html">Terms</a>
                <a href="https://ideypay.com/privacy.html">Privacy Policy</a>
              </div>
              <div className="preFooter-item">
                <h4 className="preFooter-btn">Transactions</h4>
                <a href="https://ideypay.com/buy-bitcoin">Buy Bitcoin in Nigeria</a>
                <a href="https://ideypay.com/sell-bitcoin">Sell Bitcoin in Nigeria</a>
                <a href="https://ideypay.com/buy-perfect-money">Buy Perfect Money in Nigeria</a>
                <a href="https://ideypay.com/sell-perfect-money">Sell Perfect Money in Nigeria</a>
                <a href="https://ideypay.com/sell-ethereum-in-nigeria">Sell Ethereum Instantly</a>
              </div>
              <div className="preFooter-item">
                <h4 className="preFooter-btn">Help</h4>
                <a href="https://medium.com/@ideypay">Blog</a>
                <a href="https://support.ideypay.com/knowledge-base/">Support Center</a>
                <a href="https://ideypay.com/helpcenter.html">Contact Us</a>
              </div>
          </div>
        </div>
        
        <div className="bottom-container-second">
          <h2>Contact us</h2>
          <div className="botton-container-contacts">
            <motion.a {...hoverEffect} href="https://api.whatsapp.com/send?phone=09064872434"><WhatsApp className="contact-icon" /> WhatsApp</motion.a>
            <motion.a {...hoverEffect} href="mailto:support@ideypay.com"><Email className="contact-icon" /> Send Email</motion.a>
            <motion.a {...hoverEffect} href="https://twitter.com/ideypay"><Twitter className="contact-icon" /> Twitter</motion.a>
            <motion.a {...hoverEffect} href="https://facebook.com/ideypay"><Facebook className="contact-icon" /> Facebook</motion.a>
          </div>
        </div>
      </div>
    </section>
  )
}